<span [hidden]="!sending" class="loading"></span>
<section id="agent-communication-dialog">
    <h2 mat-dialog-title>{{ dialogTitle }}</h2>

    <!-- Note -->
     <mat-dialog-content class="note-content">
        <mat-form-field class="w-100 text-area-container textarea-formfield">
            <mat-label>Note</mat-label>
            <textarea
                matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="3"
                cdkAutosizeMaxRows="5"
                [(ngModel)]="note"
                required
            ></textarea>
            <mat-error *ngIf="noteError">Note is required</mat-error>
        </mat-form-field>
    </mat-dialog-content>

    <div mat-dialog-content>
        <p>Add requirement documents</p>
    </div>

    <!-- No Documents -->
    <mat-dialog-content *ngIf="uploadFileList.length == 0">
        <p class="no-documents">No documents are currently attached.</p>
    </mat-dialog-content>

    <!-- List Documents to upload -->
    <mat-dialog-content class="file-list-content" *ngIf="uploadFileList.length > 0">
        <ul class="file-list">
            <li *ngFor="let file of uploadFileList">
                <div class="details">
                    <div class="file-name">{{ file.name }}</div>
                    <div class="file-size">{{ calculateFileSize(file.size) }}</div>
                </div>
                <div class="delete">
                    <button mat-icon-button (click)="handleDelete(file)">
                        <mat-icon aria-hidden="false" aria-label="delete icon" color="warn">delete</mat-icon>
                    </button>
                </div>
            </li>
        </ul>
    </mat-dialog-content>

    <!-- Add Document Button -->
    <mat-dialog-content class="add-button-row">
        <div class="button-row" [ngClass]="{ 'has-documents': uploadFileList.length > 0 }">
            <button mat-flat-button color="primary" (click)="fileInput.click()"><i aria-hidden="true" class="fa fa-plus"></i>&nbsp;Add Document</button>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <mrs-btn-tertiary buttonLabel="Close" buttonId="cancelButton" (click)="handleCancel()">Close</mrs-btn-tertiary>
        <button mat-flat-button color="primary" (click)="handleSend()">Send</button>
    </mat-dialog-actions>
    <input #fileInput hidden="true" type="file" id="fileInput" multiple accept="image/tiff,.tif, .pdf, .png, .jpg" (change)="handleAddFiles($event)" />
</section>